import React, { useState } from 'react';

import { ReactComponent as CheckedIcon } from 'assets/icons/checked.svg';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import { LoanInformationVariables } from 'prequalificationV2/enums/LoanInformationVariables';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import FormBody from 'components/FormBody';
import { maskMonetaryValue } from 'utils/stringUtils';
import { ReactComponent as ProsperLogo } from 'assets/images/prosper-logo.svg';
import DashboardFormHeader from 'components/DashboardFormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import ProsperJointTransitionDialog from './ProsperJointTransitionDialog';
import styles from './ProsperJointTransition.module.scss';

const ProsperJointTransition = () => {
  const {
    applicationId,
    [LoanInformationVariables.LoanAmount]: loanAmount,
    variables,
  } = useAppSelector((state) => state.application);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <DashboardFormHeader
        mainMessage={
          <>
            {variables!.borrower_first_name} and {variables!.coborrower_first_name}, You may have offers up to
            <span className={styles.substrateAmount}>{maskMonetaryValue(loanAmount)}</span>
          </>
        }
        percent={ProgressBarStatus.Done}
        isDefaultStyles
      />
      <FormBody formBodyClassName={styles.formBody}>
        <div className={styles.content}>
          <div className={styles.info}>
            <h2 className={styles.title}>Don't Stop Here — Loan Offers May Be Available</h2>
            <div className={styles.description}>
              <p className={styles.descriptionText}>
                Click 'See Prosper Offers' and we will redirect you to an HFS platform lender, Prosper, who offers
                fixed-rate, unsecured loans.
              </p>
              <div className={styles.benefit}>
                <CheckedIcon className={styles.benefitIcon} />
                <p className={styles.benefitText}>There is no impact on your credit to check offers</p>
              </div>
              <div className={styles.benefit}>
                <CheckedIcon className={styles.benefitIcon} />
                <p className={styles.benefitText}>Takes 2-minutes</p>
              </div>
            </div>
          </div>
          <Button buttonType={ButtonType.Primary} onClick={handleOpenDialog} className={styles.button}>
            See Prosper Offers
          </Button>
        </div>
        <div className={styles.lender}>
          <ProsperLogo className={styles.lenderLogo} />
          <p className={styles.lenderText}>HFS Platform Lender</p>
        </div>
      </FormBody>
      <ProsperJointTransitionDialog
        isModalOpen={isDialogOpen}
        applicationId={applicationId!}
        onClose={handleCloseDialog}
      />
    </>
  );
};

export default ProsperJointTransition;
